var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chart',{staticClass:"chart-container",attrs:{"option":_vm.option,"theme":_vm.theme,"loading":_vm.loading,"autoresize":true},on:{"zr:click":_vm.handleZrClick,"finished":_vm.handleFinished}})
}
var staticRenderFns = []

export { render, staticRenderFns }